import { Card, Hidden, Button } from '../../../MaterialUIComponents';
import { bind, React } from '../../../Imports';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IVideoEventServiceInjectedProps, VideoEventService } from '../../../state/VideoEventFreezerService';
import { IVideoRecallServiceInjectedProps, VideoRecallService } from '$State/VideoRecallFreezerService';
import { VideoEventResponse } from '$Generated/api';
import { VideoEventsSidePanel } from '../VideoDetails/DetailsSidePanel_SplitOff/VideoEvents/VideoEventsSidePanel';
import { VideoRecallSidePanel } from '../VideoDetails/DetailsSidePanel_SplitOff/VideoRecall/VideoRecallSidePanel';
import { VideoRecallFilterService } from '$State/VideoRecallEventFilterFreezerService';
import * as _ from 'lodash';

const withWidth = () => (WrappedComponent: any) => {
    const ComponentWithWidth = (props: any) => <WrappedComponent {...props} width="xs" />;
    ComponentWithWidth.displayName = `withWidth(${getDisplayName(WrappedComponent)})`;
    return ComponentWithWidth;
};

function getDisplayName(WrappedComponent: any) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

interface IDetailsSidePanelState {
    expandDetailsPaneOnMobile: boolean;
    showDeletePopup: boolean;
    disabledDeleteButton: boolean;
}

const styles = require('./DetailsSidePanel_SplitOff.scss') as {
    main: string;
    expandOnMobile: string;
    mobileEventDetailsToggleButton: string;
};

interface IDetailsSidePanelBaseProps {
    event: VideoEventResponse;
    onStatusChange: (status: string) => void;
    updateVideoEventHistory: () => void;
    eventStatus: string | undefined;
    width: any;
    onSelectVideoEvent: (eventId: string, goBack: boolean) => void;
    isVideoRecall?: boolean;
    toggleDeletePopup: (selectedId?: number) => void;
}

type IDetailsSidePanelProps = IDetailsSidePanelBaseProps & IVideoEventServiceInjectedProps & IVideoRecallServiceInjectedProps;

export interface Driver {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
}

class _DetailsSidePanel extends React.Component<IDetailsSidePanelProps, IDetailsSidePanelState> {
    constructor(props: IDetailsSidePanelProps) {
        super(props);
    }

    state: IDetailsSidePanelState = {
        expandDetailsPaneOnMobile: false,
        showDeletePopup: false,
        disabledDeleteButton: false,
    };

    @bind
    toggleExpandDetailsPaneOnMobile(): void {
        this.setState({ expandDetailsPaneOnMobile: !this.state.expandDetailsPaneOnMobile });
    }

    @bind
    toggleDeletePopup(): void {
        this.setState({ showDeletePopup: !this.state.showDeletePopup });
    }

    @bind
    changeToDisabled(disabled: boolean): void {
        this.setState({ disabledDeleteButton: disabled });
    }

    @bind
    async deleteVideoRecall(eventId: number) {
        await this.props.videoRecall.deleteVideoRecall(eventId);
    }

    @bind
    async promoteVideoRecall(eventId: number) {
        await this.props.videoRecall.PromoteVideoRecall(eventId);
    }

    @bind
    async getFullListOfSucessRecallIds(): Promise<number[]> {
        const recallFilter = {
            ...VideoRecallFilterService.getVideoRecallEventFilter(),
            eventTypes: [5],
            showVideoPipelineSuccessOnly: true,
        };

        return await this.props.videoEvents.getListOfEventIds(recallFilter);
    }

    render(): JSX.Element {
        const { expandDetailsPaneOnMobile } = this.state;

        return (
            <Card className={[styles.main, expandDetailsPaneOnMobile ? styles.expandOnMobile : ''].join(' ')}>
                {this.props.isVideoRecall ? (
                    <VideoRecallSidePanel
                        event={this.props.event}
                        eventStatus={this.props.eventStatus}
                        width={this.props.width}
                        onSelectVideoEvent={this.props.onSelectVideoEvent}
                        deleteVideoRecall={this.deleteVideoRecall}
                        promoteVideoRecall={this.promoteVideoRecall}
                        getFullListOfSucessRecallIds={this.getFullListOfSucessRecallIds}
                    />
                ) : (
                    <VideoEventsSidePanel
                        event={this.props.event}
                        eventStatus={this.props.eventStatus}
                        onSelectVideoEvent={this.props.onSelectVideoEvent}
                        onStatusChange={this.props.onStatusChange}
                        updateVideoEventHistory={this.props.updateVideoEventHistory}
                        width={this.props.width}
                    />
                )}
                <Hidden mdUp>
                    <Button
                        size="small"
                        className={styles.mobileEventDetailsToggleButton}
                        variant="text"
                        onClick={this.toggleExpandDetailsPaneOnMobile}
                    >
                        {expandDetailsPaneOnMobile ? (
                            <FontAwesomeIcon icon={faAngleDown} size="xs" />
                        ) : (
                            <FontAwesomeIcon icon={faAngleUp} size="xs" />
                        )}
                        <br />
                        {expandDetailsPaneOnMobile ? 'Collapse Details' : 'Expand Details'}
                    </Button>
                </Hidden>
            </Card>
        );
    }
}

export const DetailsSidePanelSplitOff = withWidth()(VideoRecallService.inject(VideoEventService.inject(_DetailsSidePanel)));
